import view from './view.js';

export {view};


// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_detail/editDel/index.js